import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeCoupon } from '../../api/apiStorefront';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const stripCouponFromCart = (cache) => {
  if (!cache) return cache;
  const prev = cache?.data?.data || {};
  const subtotal = Number(prev.subtotal) || 0;
  const shipping = Number(prev.shipping_total ?? prev.shipping) || 0;
  const tax = Number(prev.tax_total ?? prev.tax) || 0;
  const total = Math.max(0, subtotal + tax + shipping);

  const { coupon, ...rest } = prev;
  return {
    ...cache,
    data: {
      ...cache.data,
      data: {
        ...rest,
        discount: 0,
        discount_total: 0,
        total,
        grand_total: total,
      },
    },
  };
};

export const useRemoveCoupon = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: () => removeCoupon(),
    onSuccess: (response) => {
      queryClient.setQueryData(['cart'], (old) => stripCouponFromCart(old));
      toast.success(response?.data?.message || t('cart.couponRemoved', 'Coupon removed'));
      queryClient.invalidateQueries({ queryKey: ['cart'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message || t('cart.couponRemoveError', 'Failed to remove coupon');
      toast.error(message);
    },
  });
};
